import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate all Operations Center (Mesa de Controle) query keys.
 * Call this from any mutation that changes data visible on the Ops Center dashboard.
 */
export function invalidateOpsCenter(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['ops-metrics'] });
  queryClient.invalidateQueries({ queryKey: ['ops-workflows'] });
  queryClient.invalidateQueries({ queryKey: ['ops-bottlenecks'] });
  queryClient.invalidateQueries({ queryKey: ['ops-problems'] });
  queryClient.invalidateQueries({ queryKey: ['ops-actions'] });
  queryClient.invalidateQueries({ queryKey: ['ops-team'] });
  queryClient.invalidateQueries({ queryKey: ['ops-alerts'] });
}
